import Component, { mixins } from 'vue-class-component'

import HttpStatusCode from 'http-status-codes'

import WithRender from './AuthenticationForm.html'

import { 
  AbstractControl,
  FormControl,
  FormGroup,
  MButton, 
  MButtonType,
  MForm,
  MMessage,
  MTextfield, 
  MTextfieldType,
  MTooltip,
  RequiredValidator
} from '@ulaval/modul-components'

import AuthenticationService, { IAuthenticateRequestResponse } from '@/modules/authentication/Authentication.service';

import ROUTES from '@/router/ROUTES';
import { AxiosError } from 'axios';
import { LOCAL_STORAGE_LOGIN_REMEMBERED_ROUTE } from '@/router/helpers';

@WithRender
@Component({
  components: {
    MButton,
    MForm,
    MMessage,
    MTextfield,
    MTooltip
  }
})
export default class AuthenticationForm extends mixins(AuthenticationService) {
  public formGroup: FormGroup = new FormGroup({
    username: new FormControl<string>([
        RequiredValidator()
    ]),
    password: new FormControl<string>([RequiredValidator()])
  })
  private isAuthenticationLoadingStateActive: boolean = false
  private requestErrors: { [key: string]: boolean } = {}

  private readonly MTextfieldType: object = MTextfieldType
  private readonly MButtonType: object = MButtonType
  private readonly AUTHENTICATION_LOADING_STATE_TIMEOUT: number = 500
  private readonly ERROR_KEY_INVALID_CREDENTIALS: string = 'invalid_credentials'
  private readonly ERROR_KEY_STUDENT_NOT_FOUND: string = 'studentNotFound'

  private get usernameField(): AbstractControl<string> {
    return this.formGroup.getControl<string>('username');
  }
  private get passwordField(): AbstractControl<string> {
      return this.formGroup.getControl<string>('password');
  }

  private authenticate(): void {
    const authenticationLoadingStateTimeout: NodeJS.Timeout = setTimeout(() => {
      this.isAuthenticationLoadingStateActive = true
    }, this.AUTHENTICATION_LOADING_STATE_TIMEOUT)

    this.service_authenticationService_authenticate({
      username: this.usernameField.value,
      password: this.passwordField.value
    }).then((response: IAuthenticateRequestResponse) => {
      const rememberedRoute: string | null = localStorage.getItem(LOCAL_STORAGE_LOGIN_REMEMBERED_ROUTE)

      if (rememberedRoute) {
        this.$router.push({
          path: rememberedRoute
        })
        localStorage.removeItem(LOCAL_STORAGE_LOGIN_REMEMBERED_ROUTE)
      } else {
        this.mixin_router_navigate({
          name: ROUTES.INSCRIPTION_ETUDIANT,
          params: {
            token: response.token
          }
        })
      }
    }).catch((error: AxiosError) => {
      if (error.response && error.response.status.toString() === HttpStatusCode.NOT_FOUND.toString()) {
        this.requestErrors = {
          ...this.requestErrors,
          [this.ERROR_KEY_STUDENT_NOT_FOUND]: true
        }
      } else if (error.response && error.response.data && error.response.data.validation) {
        this.requestErrors = {
          ...this.requestErrors,
          ...error.response.data.validation
        }
      } else {
        this.requestErrors = {}
      }
    }).finally(() => {
      clearTimeout(authenticationLoadingStateTimeout)
      this.isAuthenticationLoadingStateActive = false
    })
  }
}
